import {IExpensesResponse} from "../../api/expenseService";

export interface IExpenseState {
    items: IExpensesResponse
    categories: string[]
    fetchExpensesLoading: boolean
    fetchCategoriesLoading: boolean
    actionLoading: boolean
    fetchExpensesRequestId?: string
}

export const initialExpensesState: IExpensesResponse = {
    total_pages: 0,
    count: 0,
    data: [],
}
